import CardActions from '@material-ui/core/CardActions';
import React from 'react';
import {
  Create,
  Datagrid,
  DisabledInput,
  Edit,
  EditButton,
  Filter,
  List,
  ListButton,
  LongTextInput,
  NumberField,
  NumberInput,
  ReferenceField,
  ReferenceInput,
  Responsive,
  SaveButton,
  SelectInput,
  SimpleForm,
  SimpleList,
  TextField,
  TextInput,
  Toolbar,
} from 'react-admin';

export const VenueFilter = props => (
  <Filter {...props}>
    <ReferenceInput label="Market" source="market_id" reference="markets">
      <SelectInput optionText="name" />
    </ReferenceInput>
    <TextInput label="Name" source="name" />
    <TextInput label="Address" source="address" />
    <TextInput label="Clean Name" source="clean_name" />
    <TextInput label="Clean Address" source="clean_address" />
    <NumberInput label="Min Capacity" source="capacity" />
  </Filter>
);

export const VenueList = props => (
  <List {...props} bulkActionButtons={false} filters={<VenueFilter />}>
    <Responsive
      small={
        <SimpleList
          primaryText={record => `${record.name}`}
          secondaryText={record => record.address}
        />
      }
      medium={
        <Datagrid>
          <EditButton />
          <TextField source="id" />
          <TextField source="name" />
          <TextField source="address" />
          <ReferenceField label="Market" source="market_id" reference="markets">
            <TextField source="short_name" />
          </ReferenceField>
          <NumberField source="capacity" />
        </Datagrid>
      }
    />
  </List>
);

export const VenueCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput
        label="Market"
        source="market_id"
        reference="markets"
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <LongTextInput source="name" />
      <LongTextInput source="address" />
      <LongTextInput source="city" />
      <LongTextInput source="region" />
      <NumberInput source="lat" />
      <NumberInput source="lng" />
      <NumberInput source="capacity" />
      <TextInput source="zip_code" />
    </SimpleForm>
  </Create>
);

const PostEditToolbar = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);
export const VenueEdit = props => (
  <Edit title={<VenueTitle />} actions={<VenueActions />} {...props}>
    <SimpleForm toolbar={<PostEditToolbar />}>
      <DisabledInput source="id" />
      <ReferenceInput
        label="Market"
        source="market_id"
        reference="markets"
        allowEmpty
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <LongTextInput source="name" />
      <LongTextInput source="address" />
      <LongTextInput source="city" />
      <LongTextInput source="region" />
      <NumberInput source="lat" />
      <NumberInput source="lng" />
      <NumberInput source="capacity" />
      <TextInput source="zip_code" />
    </SimpleForm>
  </Edit>
);

const VenueTitle = ({ record }) => {
  return <span>{record ? `"${record.name}"` : ''}</span>;
};

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

const VenueActions = ({ basePath, data }) => (
  <CardActions style={cardActionStyle}>
    <ListButton basePath={basePath} />
  </CardActions>
);



// WEBPACK FOOTER //
// ./src/venues.js